/**
 * Pleasance Icon Component
 * Uses wine→amber gradient transparent PNG icons (optimized 64x64px)
 */

import { useState } from 'react';

const Icon = ({ name, size = 24, className = "", alt = "" }) => {
    const [hasError, setHasError] = useState(false);

    const iconMap = {
        menu: "menu_final.png",
        close: "close_final.png",
        search: "search_final.png",
        user: "user.png",
        chevron: "chevron_final.png",
        success: "icon_success.png",
        error: "icon_error.png",
        loading: "loading_spinner.png",
        chat: "chat.png",
        send: "send.png",
        add: "add.png"
    };

    const iconPath = `/icons/${iconMap[name] || iconMap.menu}`;

    // Fallback if image fails to load
    if (hasError) {
        return (
            <span
                className={`inline-block ${className}`}
                style={{ width: size, height: size, opacity: 0.3 }}
                aria-label={alt || name}
                title={`${name} icon failed to load`}
            >
                ⚠️
            </span>
        );
    }

    return (
        <img
            src={iconPath}
            alt={alt || `${name} icon`}
            width={size}
            height={size}
            className={className}
            style={{ display: 'inline-block' }}
            onError={() => setHasError(true)}
            loading="lazy"
        />
    );
};

export default Icon;
